import { newAmsFetch, newAmsResponseRawBody, newAmsResponseData } from "./util/ams.js";
import { contentTypes } from "./util/http.js";
import * as l10nApi from "./l10n/api.js";
import * as stationsApi from "./stations/api.js";
import * as rentObjectsApi from "./rent_objects/api.js";
import * as rentContractsApi from "./rent_contracts/api.js";
import * as userApi from "./user/api.js";
import * as historyApi from "./history/api.js";
import * as cmsApi from "./cms/api.js";
export var newApi = function newApi(_ref) {
  var fetch = _ref.fetch,
    config = _ref.config;
  var amsFetch = newAmsFetch({
    fetch: fetch,
    config: config
  });
  var amsResponse = {
    contentTypes: contentTypes,
    getRawBody: newAmsResponseRawBody(amsFetch),
    getData: newAmsResponseData(amsFetch)
  };
  return {
    l10n: l10nApi.newApi({
      amsResponse: amsResponse,
      config: config
    }),
    stations: stationsApi.newApi({
      amsResponse: amsResponse,
      config: config
    }),
    rentObjects: rentObjectsApi.newApi({
      amsResponse: amsResponse,
      config: config
    }),
    rentContracts: rentContractsApi.newApi({
      amsResponse: amsResponse,
      config: config
    }),
    user: userApi.newApi({
      amsResponse: amsResponse,
      config: config
    }),
    history: historyApi.newApi({
      amsResponse: amsResponse,
      config: config
    }),
    cms: cmsApi.newApi({
      amsResponse: amsResponse,
      config: config
    })
  };
};